import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { ContasService, fmtMoeda } from '../services';

const ICONES = [
  '🏦','🏧','💰','💳','💵','💸','🪙','💎','💹','📈','📉','📊',
  '🐷','🎯','💼','📱','👛','🏠','🚗','✈️','🌟','⭐','🏆','🎁',
  '🌍','💡','🔑','🔒','🌊','🍀','🌙','☀️','🧧','🎪','💫','🔵',
  '🟢','🔴','🟡','🟣','⚡','🌈','🎵','📋','🗂️','🧾','🪴','🏅',
];

const initForm = {
  nome: '', tipo: 'corrente', subtipo: '', banco: '',
  agencia: '', numero_conta: '', saldo_inicial: '',
  cor: '#2563eb', icone: '🏦', incluir_no_total: true, observacoes: ''
};

export default function Contas() {
  const [contas, setContas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(initForm);
  const [saving, setSaving] = useState(false);
  const [erro, setErro] = useState('');

  const load = () => {
    setLoading(true);
    ContasService.listar().then(setContas).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const openNew = () => { setEditing(null); setForm(initForm); setErro(''); setModal(true); };
  const openEdit = (c) => {
    setEditing(c);
    setForm({ ...c, saldo_inicial: c.saldo_inicial, incluir_no_total: !!c.incluir_no_total });
    setErro('');
    setModal(true);
  };

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true); setErro('');
    try {
      if (editing) await ContasService.atualizar(editing.id, form);
      else await ContasService.criar(form);
      setModal(false); load();
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Excluir esta conta?')) return;
    try { await ContasService.excluir(id); load(); }
    catch (err) { alert(err.response?.data?.erro || 'Erro ao excluir'); }
  };

  const totalAtivos = contas.filter(c => c.ativo && c.incluir_no_total && c.tipo !== 'investimento')
    .reduce((s, c) => s + parseFloat(c.saldo_atual), 0);
  const totalInvest = contas.filter(c => c.ativo && c.tipo === 'investimento')
    .reduce((s, c) => s + parseFloat(c.saldo_atual), 0);

  return (
    <Layout title="Contas">
      <div className="flex-between mb-3">
        <div className="flex-gap">
          <div className="stat-card saldo" style={{ margin: 0, minWidth: 180 }}>
            <span className="stat-label">Saldo em Contas</span>
            <span className="stat-value" style={{ fontSize: 18 }}>{fmtMoeda(totalAtivos)}</span>
          </div>
          <div className="stat-card investimento" style={{ margin: 0, minWidth: 180 }}>
            <span className="stat-label">Em Investimentos</span>
            <span className="stat-value" style={{ fontSize: 18 }}>{fmtMoeda(totalInvest)}</span>
          </div>
        </div>
        <button className="btn btn-cta" onClick={openNew}>+ Nova Conta</button>
      </div>

      {loading ? (
        <div className="loading-wrap"><div className="spinner" /></div>
      ) : contas.length === 0 ? (
        <div className="empty-state card">
          <div className="empty-icon">🏦</div>
          <p>Nenhuma conta cadastrada.</p>
          <button className="btn btn-cta mt-2" onClick={openNew}>Criar primeira conta</button>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16 }}>
          {contas.map(c => (
            <div key={c.id} className="card" style={{ opacity: c.ativo ? 1 : .6 }}>
              <div className="account-card" style={{ background: `linear-gradient(135deg, ${c.cor}, ${c.cor}bb)` }}>
                <div className="flex-between">
                  <div>
                    <div style={{ fontSize: 11, opacity: .8, textTransform: 'uppercase', letterSpacing: '.05em' }}>
                      {c.tipo.replace('_', ' ')}
                    </div>
                    <div style={{ fontWeight: 700, fontSize: 15, marginTop: 2 }}>{c.nome}</div>
                    {c.banco && <div style={{ fontSize: 11, opacity: .8, marginTop: 2 }}>{c.banco}</div>}
                  </div>
                  <span style={{ fontSize: 30 }}>{c.icone || '🏦'}</span>
                </div>
                <div>
                  <div style={{ fontSize: 11, opacity: .8 }}>Saldo atual</div>
                  <div style={{ fontWeight: 700, fontSize: 22 }}>{fmtMoeda(c.saldo_atual)}</div>
                </div>
              </div>
              <div style={{ padding: '10px 16px', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button className="btn-action btn-action-edit" title="Editar" onClick={() => openEdit(c)}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/>
                  </svg>
                </button>
                <button className="btn-action btn-action-delete" title="Excluir" onClick={() => handleDelete(c.id)}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/>
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal modal-md" style={{ overflow: 'hidden' }}>

            {/* Header com gradiente azul bancário */}
            <div style={{
              padding: '16px 22px',
              background: 'linear-gradient(135deg,#eff6ff,#dbeafe)',
              borderBottom: '2px solid #93c5fd',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}>
              <div>
                <div style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.09em', color: 'var(--gray-400)', marginBottom: 2 }}>
                  {editing ? 'Editar' : 'Nova'} Conta
                </div>
                <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--primary)', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 22 }}>{form.icone}</span>
                  {form.nome || 'Conta Bancária'}
                </div>
              </div>
              <button className="modal-close" onClick={() => setModal(false)}>×</button>
            </div>

            <form onSubmit={handleSave}>
              <div className="modal-body" style={{ background: '#f7f9fc', gap: 14 }}>
                {erro && <div className="alert alert-danger">{erro}</div>}

                <div className="form-grid">
                  <div className="form-group" style={{ gridColumn: '1/-1' }}>
                    <label className="form-label">Nome da conta *</label>
                    <input className="form-control" value={form.nome} required
                      placeholder="Ex: Nubank, Bradesco Principal..."
                      onChange={e => setForm(p => ({ ...p, nome: e.target.value }))} />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Tipo *</label>
                    <select className="form-control" value={form.tipo}
                      onChange={e => setForm(p => ({ ...p, tipo: e.target.value }))}>
                      <option value="corrente">Conta Corrente</option>
                      <option value="poupanca">Poupança</option>
                      <option value="investimento">Investimento</option>
                      <option value="carteira_digital">Carteira Digital</option>
                      <option value="carteira">Carteira (Dinheiro)</option>
                      <option value="outro">Outro</option>
                    </select>
                  </div>

                  {form.tipo === 'investimento' && (
                    <div className="form-group">
                      <label className="form-label">Subtipo</label>
                      <select className="form-control" value={form.subtipo || ''}
                        onChange={e => setForm(p => ({ ...p, subtipo: e.target.value }))}>
                        <option value="">Selecionar...</option>
                        <option value="renda_fixa">Renda Fixa</option>
                        <option value="renda_variavel">Renda Variável</option>
                        <option value="tesouro">Tesouro Direto</option>
                        <option value="cdb">CDB</option>
                        <option value="lci_lca">LCI/LCA</option>
                        <option value="acoes">Ações</option>
                        <option value="fundos">Fundos</option>
                        <option value="criptomoedas">Criptomoedas</option>
                        <option value="previdencia">Previdência</option>
                        <option value="outro">Outro</option>
                      </select>
                    </div>
                  )}

                  <div className="form-group">
                    <label className="form-label">Banco / Instituição</label>
                    <input className="form-control" value={form.banco || ''} placeholder="Ex: Nubank, Itaú..."
                      onChange={e => setForm(p => ({ ...p, banco: e.target.value }))} />
                  </div>

                  {!editing && (
                    <div className="form-group">
                      <label className="form-label">Saldo inicial (R$)</label>
                      <input type="number" step="0.01" className="form-control" value={form.saldo_inicial}
                        placeholder="0,00"
                        onChange={e => setForm(p => ({ ...p, saldo_inicial: e.target.value }))} />
                    </div>
                  )}

                  {/* Cor */}
                  <div className="form-group">
                    <label className="form-label">Cor do cartão</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <input type="color" value={form.cor} onChange={e => setForm(p => ({ ...p, cor: e.target.value }))}
                        style={{ width: 48, height: 40, padding: 3, border: '1.5px solid var(--gray-200)', borderRadius: 8, cursor: 'pointer' }} />
                      <div style={{ flex: 1, height: 40, borderRadius: 8, background: `linear-gradient(135deg, ${form.cor}, ${form.cor}bb)`, display: 'flex', alignItems: 'center', paddingLeft: 12, color: 'white', fontWeight: 700, fontSize: 13 }}>
                        {form.nome || 'Pré-visualização'}
                      </div>
                    </div>
                  </div>

                  {/* Picker de ícones */}
                  <div className="form-group" style={{ gridColumn: '1/-1' }}>
                    <label className="form-label" style={{ marginBottom: 8 }}>Ícone da conta</label>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, padding: '12px', background: 'white', borderRadius: 10, border: '1.5px solid var(--gray-200)', maxHeight: 175, overflowY: 'auto', boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}>
                      {ICONES.map(ic => (
                        <button key={ic} type="button"
                          onClick={() => setForm(p => ({ ...p, icone: ic }))}
                          style={{
                            width: 40, height: 40, fontSize: 20, borderRadius: 9, cursor: 'pointer',
                            border: `2px solid ${form.icone === ic ? 'var(--primary)' : 'transparent'}`,
                            background: form.icone === ic ? 'var(--primary-light)' : 'var(--gray-50)',
                            transition: 'all .15s', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            boxShadow: form.icone === ic ? '0 2px 8px rgba(37,99,235,.25)' : 'none',
                          }}>
                          {ic}
                        </button>
                      ))}
                    </div>
                    <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontSize: 24 }}>{form.icone}</span>
                      <span style={{ fontSize: 12, color: 'var(--gray-400)', fontWeight: 500 }}>Ícone selecionado</span>
                    </div>
                  </div>

                  {/* Incluir no total — toggle */}
                  <div style={{ gridColumn: '1/-1' }}>
                    <div
                      onClick={() => setForm(p => ({ ...p, incluir_no_total: !p.incluir_no_total }))}
                      style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        padding: '12px 16px', borderRadius: 12, cursor: 'pointer',
                        background: form.incluir_no_total ? '#eff6ff' : 'white',
                        border: `1.5px solid ${form.incluir_no_total ? '#93c5fd' : 'var(--gray-200)'}`,
                        boxShadow: form.incluir_no_total ? '0 2px 10px rgba(37,99,235,.12)' : '0 1px 3px rgba(0,0,0,.06)',
                        transition: 'all .2s', userSelect: 'none',
                      }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={{ width: 36, height: 36, borderRadius: 9, background: form.incluir_no_total ? '#eff6ff' : 'var(--gray-100)', border: `1px solid ${form.incluir_no_total ? '#93c5fd' : 'var(--gray-200)'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 17, flexShrink: 0 }}>📊</div>
                        <div>
                          <div style={{ fontSize: 13, fontWeight: 600, color: form.incluir_no_total ? 'var(--primary)' : 'var(--gray-700)' }}>Incluir no total patrimonial</div>
                          <div style={{ fontSize: 11, color: 'var(--gray-400)' }}>Soma ao saldo geral do dashboard</div>
                        </div>
                      </div>
                      <div style={{ width: 40, height: 22, borderRadius: 11, background: form.incluir_no_total ? 'var(--primary)' : 'var(--gray-300)', position: 'relative', transition: 'background .25s', flexShrink: 0 }}>
                        <div style={{ width: 18, height: 18, borderRadius: '50%', background: 'white', position: 'absolute', top: 2, left: form.incluir_no_total ? 20 : 2, transition: 'left .25s', boxShadow: '0 1px 4px rgba(0,0,0,.25)' }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer" style={{ background: '#f7f9fc', borderTop: '1px solid var(--gray-200)' }}>
                <button type="button" className="btn btn-ghost" onClick={() => setModal(false)}>Cancelar</button>
                <button type="submit" disabled={saving} style={{
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                  padding: '9px 22px', borderRadius: 9, border: 'none', cursor: 'pointer',
                  fontWeight: 700, fontSize: 14, color: 'white', transition: 'all .2s',
                  background: 'linear-gradient(135deg,var(--primary),#4f46e5)',
                  boxShadow: '0 4px 14px rgba(37,99,235,.35)',
                  opacity: saving ? 0.7 : 1,
                }}>
                  {saving ? 'Salvando...' : '✓ Salvar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
}
